module.exports = __webpack_public_path__ + "img/cooperationMobile.628854a0.png";